import React from 'react'
import RichText from '../../../components/atoms/rich-text/rich-text'
import './aboutEvent.scss'

const aboutEvent = (props) => {
  const { aboutInfo } = props
  return (
    <div className="a-about-event">
      <RichText jsonInfo={aboutInfo?.json} className="f-info" />
    </div>
  )
}

export default aboutEvent
